export function copyText(text) {
  const node = _createNode(text);
  document.body.appendChild(node);
  _copyNode(node);
  document.body.removeChild(node);
}

function _createNode(text) {
  const node = document.createElement('textarea');
  node.style.position = 'absolute';
  node.textContent = text;
  node.style.left = '-10000px';
  node.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
  return node;
}

function _copyNode(node) {
  try {
    // Set inline style to override css styles
    document.body.style.webkitUserSelect = 'initial';

    const selection = document.getSelection();
    selection.removeAllRanges();
    node.select();

    if(!document.execCommand('copy')) {
      throw new Error('failure copy');
    }
    selection.removeAllRanges();
  } finally {
    // Reset inline style
    document.body.style.webkitUserSelect = '';
  }
}

let handler;

function handleCopyClick({ element, params }) {
  try {
    copyText(params.copyText, element[0]);
    element.querySelector('i').classList.add('text-success');
    
    setTimeout(() => {
      element.querySelector('i').classList.remove('text-success');
    }, 400);
        
    // TODO: Pass success and error callback functions in params
        
  } catch (err) {
    console.error(err);
    // TODO: Pass success and error callback functions in params
  }
}

export default {
  bind(element, { value }) {
    handler = handleCopyClick.bind(null, { element, params: value });
    
    element.addEventListener('click', handler);
  },
  update(element, { value, oldValue }) {
    if (oldValue && value !== oldValue) {
      element.removeEventListener('click', handler);
      handler = handleCopyClick.bind(null, { element, params: value });
    
      element.addEventListener('click', handler);
    }
  },
  unbind(element) {
    element.removeEventListener('click', handler);
  }
};